<template>
  <div
    class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-md tw-border-2 tw-p-3 tw-border-system-error-500 tw-bg-system-error-100"
    role="alert"
    data-test-id="user-not-connected-to-m365-warning-banner"
  >
    <div
      class="tw-bg-system-error-200 tw-p-1 tw-rounded-full tw-text-system-error-500"
    >
      <cl-icon-tabler-alert-triangle
        data-test-id="user-not-connected-to-m365-warning-banner"
      />
    </div>
    <div class="tw-flex-grow tw-whitespace-normal tw-break-words">
      <div
        class="tw-text-lg tw-font-semibold"
        data-test-id="user-not-connected-to-m365-warning-banner"
      >
        {{ t("banner-title-account-not-protected") }}
      </div>
      <div data-test-id="user-not-connected-to-m365-warning-banner">
        {{ t("banner-text-connect-m365-account") }}
      </div>
    </div>
    <div class="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center">
      <router-link
        v-if="!isOnConnectionPage"
        v-slot="{ href, navigate }"
        :to="{ name: CONNECTION_PAGE_NAME }"
      >
        <a
          :href="href"
          class="tw-underline tw-text-branding-blue-500"
          @click="navigate"
          >{{ t("button-add-connection") }}</a
        >
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const CONNECTION_PAGE_NAME = "customer-settings-connections";
const { t } = useI18n();
const store = useStore();
const route = useRoute();

const getMailFlow = computed(() => store.getters["history/getMailFlow"]);
const isOnConnectionPage = computed<boolean>(() => {
  return route.name === CONNECTION_PAGE_NAME;
});

watch(
  getMailFlow,
  (newVal) => {
    return newVal;
  },
  { deep: true },
);
</script>
